import React from 'react';
import { ReactComponent as HeartIcon } from '../../../assets/img/heart.svg';

export const Footer = () => {
  return (
    <footer className='text-center mt-2 mb-3' style={{color:'white'}}>
      <div>
        <a style={{color:'white'}}
          {...{
            target: '_blank'
          }}
          className='d-flex align-items-center'
          href='https://multiversx.com/'
        >
          Made with <HeartIcon className='mx-1' /> by Super Rare Bear team
        </a>
      </div>
    </footer>
  );
};
